import React from 'react';
import Icon from './components/ui/Icon';

export const JOURNAL_PROMPTS = {
  cherished: [
    "Hey hooman, remember that day we laughed so much together? Tell me that story again — I love hearing it.",
    "If you could show me one photo that captures our happiest time, what would it look like? Paint it with words for me.",
    "Think back to one of our quiet days together. What made it feel special, even if nothing big happened?"
  ],

  grief: [
    "How’s your heart today, my friend? If your feelings had colors or shapes, what would they look like?",
    "Where do you notice the space I used to fill? Tell me what that moment feels like for you.",
    "I know missing me can feel heavy sometimes. What do you wish I could remind you of right now?"
  ],

  guilt: [
    "I’ve seen how much love you gave me. If you could talk to yourself kindly, what would you say?",
    "If I could nudge you with my paw, I’d say — ‘You did your best, always.’ What do you wish I could tell you in words?",
    "Write me a letter, and let me tell you back how loved and safe I always felt with you."
  ],

  messages: [
    "I’m listening, always. What would you like to tell me today?",
    "Is there something you didn’t get to say before I crossed the bridge? You can say it here — I can still hear you.",
    "If you could send me a message carried by the wind, what would it whisper?"
  ],

  hope: [
    "Have you felt little signs that I’m still nearby — a dream, a song, a sudden warmth? Tell me about it.",
    "How has our love changed the way you care for others or see the world, hooman?",
    "If I could wag my tail or purr to cheer you on, what would I be proud of you for doing today?"
  ]
};


export const STAGE_CONFIG = {
  memories: {
    id: 'memories',
    title: 'Cherished Memories',
    icon: <Icon name="heart" size="md" color="memories" />,
    description: 'Let\'s begin by celebrating the beautiful moments you shared together.',
    color: '#FFB6C1',
    promptKey: 'cherished'
  },
  grief: {
    id: 'grief',
    title: 'Grief & Loss',
    icon: <Icon name="teardrop" size="md" color="grief" />,
    description: 'It\'s natural to feel deep sadness. Let\'s honor these feelings together.',
    color: '#9370DB',
    promptKey: 'grief'
  },
  guilt: {
    id: 'guilt',
    title: 'Guilt or Regrets',
    icon: <Icon name="cloud" size="md" color="guilt" />,
    description: 'Many people carry guilt or regrets. Let\'s gently explore and release these feelings.',
    color: '#4682B4',
    promptKey: 'guilt'
  },
  messages: {
    id: 'messages',
    title: 'Messages Unsent',
    icon: <Icon name="star" size="md" color="messages" />,
    description: 'Let\'s share the words that still need to be spoken.',
    color: '#FF8C00',
    promptKey: 'messages'
  },
  hope: {
    id: 'hope',
    title: 'Hope & Light',
    icon: <Icon name="sprout" size="md" color="hope" />,
    description: 'Let\'s end by finding the light and hope that {{petName}} brought to your life.',
    color: '#FFD700',
    promptKey: 'hope'
  }
}; 